import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
  NextPage,
} from 'next'
import { useRouter } from 'next/router'

import { useErrorBoundary } from 'react-error-boundary'

import { dinnerNewDinner } from '~/api-client/food_api/dinner'
import { staticGetDinnerOptionList } from '~/api-client/food_api/static'
import { DinnerForm } from '~/components/food_app/dinner/DinnerForm'
import { ChevronLeftIcon } from '~/components/icons'
import { Footer } from '~/components/layout/Footer'
import { Header } from '~/components/layout/Header'
import { useSession } from '~/provider/SessionProvider'

const Page: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = (
  props
) => {
  const router = useRouter()

  const { showBoundary } = useErrorBoundary()
  const session = useSession({ loginRequired: true })
  const accessToken = session.response?.data.accessToken

  return (
    <>
      <Header>
        <div className="w-5">
          <ChevronLeftIcon fill="#fff" onClick={() => router.back()} />
        </div>
        新規作成
        <div className="w-5" />
      </Header>

      <DinnerForm
        staticDinnerOptionListResponse={props.staticDinnerOptionListResponse}
        onSubmit={async (body) => {
          if (accessToken) {
            try {
              const dinner = await dinnerNewDinner({
                accessToken,
                body,
              })
              await router.push(`/dinners/${dinner.dinner.dinnerId}/complete`)
            } catch (e) {
              showBoundary(e)
            }
          }
        }}
      />

      <Footer />
    </>
  )
}

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const props = {
    staticDinnerOptionListResponse: await staticGetDinnerOptionList(),
  }
  return { props }
}

export default Page
